<template>
  <div class="conversion-modal">
    <div v-if="!products">{{ $t('loading') }}</div>
    <div v-else-if="products.length === 0">{{ $t('no-products') }}</div>
    <table v-else>
      <thead>
        <tr>
          <th>{{ $t('product') }}</th>
          <th>{{ $t('material') }}</th>
          <th>{{ $t('value-per-unit') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ uuid, name, material, value } in products" :key="`product.${uuid}`">
          <td>{{ name }}</td>
          <td>{{ $t(`materials.${material}`) }}</td>
          <td>
            <RecyCoinIcon />
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<i18n>
  {
    "es": {
      "loading": "Cargando...",
      "no-products": "No hay productos disponibles para entrega",
      "product": "Producto",
      "material": "Material",
      "value-per-unit": "Valor por unidad",
      "materials": {
        "PET": "PET",
        "HDPE": "PEAD",
        "PVC": "PVC",
        "LDPE": "PEBD",
        "PP": "PP",
        "PS": "PS",
        "OTHER": "OTHER"
      }
    },
    "en": {
      "loading": "Loading...",
      "no-products": "There are no products available for exchange",
      "product": "Product",
      "material": "Material",
      "value-per-unit": "Coins per unit",
      "materials": {
        "PET": "PET",
        "HDPE": "HDPE",
        "PVC": "PVC",
        "LDPE": "LDPE",
        "PP": "PP",
        "PS": "PS",
        "OTHER": "OTHER"
      }
    }
  }
</i18n>

<script>
  import { RecyCoinIcon } from '@/components/recyco';

  export default {
    name: 'conversion-table',
    components: {
      RecyCoinIcon,
    },
    props: {
      products: {
        type: Array,
      },
    },
  };
</script>

<style lang="scss" scoped>
  table {
    border-collapse: collapse;
    padding: 2em;
  }

  th, td {
    border: 1px solid var(--color-background-accent);
    padding: 0.25em 2em;
  }

  .conversion-modal {
    padding: 1em;
    width: 100%;
  }
</style>
